(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) :
  factory();
})((function () { 'use strict';

  /*
   * Controls "Read more" text links.
   */

  (function(){
    /*
     * User interaction on Read More links
     *
     * Sometimes this element uses .more-btn, sometimes not.
     * Sample: <a class="more-btn" role="button" data-target="#prod-req" data-type="reveal">Production Equipment Requirements</a>
     * Sample: <a class="more-btn closed" role="button" data-target="#bio" data-type="reveal">Continue reading</a>
     *
     * IMPORTANT: ONLY use the "closed" class on buttons whose text should change!
     *
     * Put the id and the hidden class on the ROW containing the content to be revealed - don't use this on sections, please.
     * Alternately, just wrap text in a div immediately following the button, if the layout allows for it.
     *
     * Added logic for sibling containers, when you only want to allow one open at a time:
     * <a class="cta-btn exclusive" role="button" data-target="#engineering" data-type="reveal">Get the free engineering kit</a>
     */
    let read_more_items = document.querySelectorAll('[data-type="reveal"]');
    if (!read_more_items) return;

    for (let link of read_more_items) {
      link.addEventListener('click', (e) => {
        let target = e.currentTarget,  // target is an <a>
            targets_link = target.getAttribute('data-target'),  // get the link target
            linked_content = document.querySelector(targets_link);  // go find the intended read more section
        e.preventDefault();
        // close anything open (row-reveal goes on the same element as teh hidden)
        if (target.classList.contains('exclusive') && (-1 !== linked_content.className.indexOf('hidden'))) {
          let all_rows = document.querySelectorAll('.row-reveal');
          for (let row of all_rows) {
            if ( ('#'+row.id) !== targets_link) {
              if (-1 !== row.className.indexOf('hidden')) ; else { row.className += ' hidden'; }
            } else {
              linked_content.className = linked_content.className.replace(' hidden', '');
            }
          }
        } else {
          // toggle the linked_content class
          // for SELECT buttons, toggle the target class and change the text
          if (-1 !== linked_content.className.indexOf('hidden')) {
            if (target.classList.contains('closed')) {
              target.className = target.className.replace(' closed', ' open');
              target.innerText = 'Close this section';
            }
            linked_content.className = linked_content.className.replace(' hidden', '');
          } else {
            if (target.classList.contains('open')) {
              target.className = target.className.replace(' open', ' closed');
              target.innerText = 'Continue reading';
            }
            linked_content.className += ' hidden';
          }
        }
      }, false);
    }
  })();

}));
